module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_row_2.0012bccb.png";